import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  // iconWrapper: {
  //   display: 'flex',
  //   justifyContent: 'center',
  // },
  // iconContainer: {
  //   width: 18,
  //   height: 18,
  // },
  // tableText: {
  //   fontSize: 12,
  // },
  // printTable: {
  //   padding: 20,
  // },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
    gap: 4,
  },
  containerTitleWrapper: {
    position: 'sticky',
    top: 0,
    background: 'white',
    zIndex: 99,
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'stretch',
    color: theme.colors.darkGray,
    fontSize: 14,
    padding: '0 25px',
    borderBottom: '1px solid ' + theme.colors.lightGray,
  },
  titleStructure: {
    display: 'flex',
    flex: 1,
  },
  titleFS: {
    display: 'flex',
    paddingRight: 10,
  },
  containerContentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
  },
  contentSizesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  contentSize: {
    display: 'flex',
    alignItems: 'center',
    height: 24,
    color: theme.colors.darkGray,
    paddingRight: 30,
  },
  contentDescription: {
    color: theme.colors.darkGray,
    marginLeft: 10,
    textOverflow: 'ellipsis',
  },
  noPointerTree: {
    '.ant-tree-node-content-wrapper': {
      cursor: 'default !important' as any,
      '&:hover, &.ant-tree-node-selected, &:focus, &:active': {
        backgroundColor: 'transparent !important' as any,
      },
    },
    '.ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected': {
      backgroundColor: 'transparent !important' as any,
    },
  },
});
